<template>
  <span class="dash-avatar" :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.max(10, size * 0.36)}px` }" :title="fullName">
    <img v-if="photoUrl && !imageFailed" :src="photoUrl" :alt="fullName" @error="imageFailed = true" />
    <span v-else>{{ initials }}</span>
  </span>
</template>

<script>
import { STORAGE_URL, PROFILE_PICTURES_DIR } from '@/utils/const';

export default {
  name: 'EmployeeAvatar',
  props: {
    employee: { type: Object, default: null },
    size: { type: Number, default: 36 },
  },
  data() {
    return { imageFailed: false };
  },
  watch: {
    photoUrl() {
      this.imageFailed = false;
    },
  },
  computed: {
    fullName() {
      if (!this.employee) return '';
      return `${this.employee.fname ?? ''} ${this.employee.lname ?? ''}`.trim();
    },
    initials() {
      if (!this.employee) return '?';
      const f = (this.employee.fname ?? '').charAt(0);
      const l = (this.employee.lname ?? '').charAt(0);
      return `${f}${l}` || '?';
    },
    photoUrl() {
      if (this.employee && this.employee.profilePhoto) {
        return `${STORAGE_URL}/${PROFILE_PICTURES_DIR}/${this.employee.profilePhoto}`;
      }
      return null;
    },
  },
};
</script>
